import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=66f75cb3&scoped=true&"
import script from "./Notify.vue?vue&type=script&lang=ts&"
export * from "./Notify.vue?vue&type=script&lang=ts&"
import style0 from "./Notify.vue?vue&type=style&index=0&id=66f75cb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f75cb3",
  null
  
)

export default component.exports